import { normalizeFilterSuids, setFilterSuids } from "./filterSuids";
import { SearchParamType } from "./types/SearchParamType";
var MAX_JOB_TYPE_SUIDS = 25;
export function normalizeJobTypeSuids(values) {
    return normalizeFilterSuids(values).slice(0, MAX_JOB_TYPE_SUIDS);
}
export function getJobTypeSuids(searchParams) {
    return normalizeJobTypeSuids(searchParams.getAll(SearchParamType.JOB_TYPE_SUID));
}
export function setJobTypeSuids(searchParams, values) {
    setFilterSuids(searchParams, SearchParamType.JOB_TYPE_SUID, normalizeJobTypeSuids(values));
}
